import { render, staticRenderFns } from "./system.vue?vue&type=template&id=dc0f500a&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"
import style0 from "./system.vue?vue&type=style&index=0&id=dc0f500a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f500a",
  null
  
)

export default component.exports